import _ from 'lodash';
import Raven from 'raven-js';

export class BlockingCalloutService {
    constructor($compile, $rootScope, $document, GENERIC_ERROR_MESSAGE, GENERIC_ERROR) {
        'ngInject';
        Object.assign(this, { $compile, $rootScope, $document, GENERIC_ERROR_MESSAGE, GENERIC_ERROR });
        this.show = _.debounce(msg => this._displayPopup(msg), 500, { leading: true });
        this._messageStack = [];
    }

    error(errorMessage, error = this.GENERIC_ERROR, config = {}) {
        if (!errorMessage) {
            errorMessage = this.GENERIC_ERROR_MESSAGE;
            Raven.captureMessage('Generic error captured', {
                level: 'error',
                extra: { error }
            });
        }

        this._displayPopup(errorMessage, config);

        return { errorMessage, error };
    }

    _displayPopup(message, config = {}) {
        if (this._messageStack.length && this._messageStack[this._messageStack.length - 1] === message) {
            return;
        }

        this._messageStack.push(message);

        let body;
        let scope = this.$rootScope.$new(true);

        const container = angular.element(`
            <blocking-callout
                cancel-callback="cancelCallback"
                cancel-text="cancelText"
                close-callback="closeCallback"
                message="message"
                ok-callback="okCallback"
                ok-text="okText"
            ></blocking-callout>
        `);

        if (typeof message === 'string') {
            scope.message = message;
        } else {
            body = message;
            container.append(body);
        }

        // The caller may pass in message as part of the config, which would override the message
        // argument to this function for display purposes.
        Object.assign(scope, config);

        const target = angular.element(this.$document[0].querySelector('#modal-container'));

        scope.closeCallback = () => {
            container.remove();
            this._messageStack.pop();
        };

        target.append(container);
        this.$compile(container)(scope);
    }
}
